import React, { useCallback, useEffect, useState } from 'react';

import { MenuItem, Stack, TextField, Typography } from '@mui/material';

import UsersService from '~/services/UsersService';

export type EmployeeUser = {
  full_name: string;
  id_account: string;
  email: string;
};

type Props = {
  user: App.User;
  isAdmin?: boolean;
  onUpdatePreferredAgent?: (agentId: string) => void;
  placeholder?: string;
  filterRoles?: Array<string>;
};

export default function EmployeeUserList({ user, isAdmin, onUpdatePreferredAgent, placeholder, filterRoles }: Props) {
  const [employeeUserList, setEmployeeUserList] = useState<Array<EmployeeUser>>([]);

  const fetchEmployeeUsers = useCallback(async () => {
    const users = await UsersService.getEmployeeUsers();

    if (filterRoles) {
      const filteredUsers = users.filter((user) => {
        return filterRoles.every((r: string) => user.inline_roles?.includes(r));
      });
      setEmployeeUserList(filteredUsers);
      return;
    }
    setEmployeeUserList(users);
  }, [filterRoles]);

  useEffect(() => {
    fetchEmployeeUsers();
  }, [fetchEmployeeUsers]);

  if (isAdmin) {
    return (
      <TextField
        variant="outlined"
        value={user.preferred_agent_id}
        onChange={(e) => onUpdatePreferredAgent?.(e.target.value)}
        InputLabelProps={{ shrink: true }}
        SelectProps={{ displayEmpty: true }}
        select
        fullWidth
        placeholder={placeholder}
        size="small"
      >
        <MenuItem value="">{placeholder}</MenuItem>
        {employeeUserList?.map((item) => (
          <MenuItem key={item.id_account} value={item.id_account}>
            <Stack direction="row" spacing={1} alignItems="center" alignContent="center">
              <Typography variant="body2">{item.full_name}</Typography>
              {item.email && <Typography variant="body2">({item.email})</Typography>}
            </Stack>
          </MenuItem>
        ))}
      </TextField>
    );
  }

  return <>{employeeUserList?.find((emp) => emp.id_account === user.preferred_agent_id)?.full_name ?? ''}</>;
}
